import * as Api from '@/api/user'
import { localSave,localRead } from '@/libs/util'

const state={
    loginUser:{},
    mySalesId:'',   //我的上级代理人id
    // posterUrl:'',
    // currentProductId:'',
};

const getters={
    getLoginUser(state){
        //获取缓存的用户openid
        if(state.loginUser.openid){
            //console.log('state缓存');
            return state.loginUser;
        }else{
            let userStr = localRead('LOGIN_USER');
            // console.log('local storage里去出来',userStr);
            if(userStr==='undefined' || !userStr){
                return null;
            }else{
                return JSON.parse(userStr);
            }
        }
    },
    getMySalesId(state){
        return state.mySalesId;
    },
    // getPosterUrl(state){
    //     if(state.posterUrl){
    //         return state.posterUrl;
    //     }else{
    //         return getCookieValue('PosterPreviewUrl');
    //     }
    // },
    // getCurrentProductId(state){
    //     if(state.currentProductId){
    //         return state.currentProductId;
    //     }else{
    //         return getCookieValue('CurrentProductId');
    //     }
    // }
};

const mutations={
    setUser(state,info){
        state.loginUser = info;
        //存入localStorage
        localSave('LOGIN_USER',JSON.stringify(info));
    },
    setMySalesId(state,mySalesId){
        state.mySalesId=mySalesId;
    },
    // setPosterUrl(state,posterUrl){
    //     state.posterUrl=posterUrl;
    //     setCookieValue('PosterPreviewUrl',posterUrl);
    // },
    // setCurrentProductId(state,val){
    //     state.currentProductId=val;
    //     setCookieValue('CurrentProductId',val);
    // }
};

const actions={
    //------- 微信授权登录 ----------
    async WeixinLogin({commit},param){
        let res = await Api.weixin_login(param);
        if(res.data.status===0){
            //登录成功
            commit('setUser',res.data.responseObject);
        }
        return res.data;
    },
    async UpdateUserInfo(context,param){
        let res = await Api.user_info_update(param);
        return res.data;
    },
    async WeixinCreateOrder(context,param){
        let res = await Api.weixin_create_order(param);
        return res.data;
    },
    async WeixinPayCheck(context,param){
        let res = await Api.weixin_pay_check(param);
        return res.data;
    },
    async GetSaleOrderTicketInfo(context,param){
        let res = await Api.get_sale_order_ticket_info(param);
        return res.data.responseObject;
    },
    async GetAppBanner(context,param){
        let res = await Api.get_app_banner(param);
        return res.data.responseObject;
    },
    async GetAppCSInfo(context,param){
        let res = await Api.get_app_cs_info(param);
        return res.data.responseObject;
    },
    async GetMyETicketList(context,param){
        let res = await Api.get_my_e_ticket_list(param);
        return res.data.responseObject;
    },
    async GetOrderDetail(context,param){
        let res = await Api.get_order_detail(param);
        return res.data.responseObject;
    },
    async WeixinOrderPayment(context,param){
        let res = await Api.weixin_order_payment(param);
        return res.data;
    },
    async WeixinSdkConfig(context,param){
        let res = await Api.weixin_sdk_config(param);
        return res.data;
    },
    async CreateGiveawayOrder(context,param){
        let res = await Api.create_giveaway_order(param);
        return res.data;
    },
    async GetAgentStatisticData(context,param){
        let res = await Api.get_agent_statistic_data(param);
        return res.data.responseObject;
    },
    async GetAgentCommissionBalance(context,param){
        let res = await Api.get_agent_commission_balance(param);
        return res.data.responseObject;
    },
    async GetSaleOrderExpressInfo(context,param){
        let res = await Api.get_sale_order_express_info(param);
        return res.data.responseObject;
    },
    async GetSaleOrderExpressStatus(context,param){
        let res = await Api.get_sale_order_express_status(param);
        return res.data.responseObject;
    },
    async ApplyMember(context,param){
        let res = await Api.apply_member(param);
        return res.data;
    },
    async CheckETicket(context,param){
        let res = await Api.check_e_ticket(param);
        return res.data;
    },
    async GetSystemParam(context,param){
        let res = await Api.get_system_param(param);
        return res.data.responseObject;
    },
    async GetTheProductUserCoupon(context,param){
        let res = await Api.get_the_product_user_coupon(param);
        return res.data.responseObject;
    },
    async GetMyRewardList(context,param){
        let res = await Api.get_my_reward_list(param);
        return res.data.responseObject;
    },
    async GetGiveawayLink(context,param){
        let res = await Api.get_giveaway_link(param);
        return res.data;
    },
};

export default {
    state,
    getters,
    mutations,
    actions
}
